module.exports = "/_next/static/files/bfd6d681c555d82bd03a56ed174dd19b.jpg";